// parse MS formatted dates from json
// this isn't the most efficient code because if you include this script on your page it will parse
// every JSON block for date strings, but for many cases this is good enough.
// based on code from http://www.west-wind.com/Weblog/posts/729630.aspx
var reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/;
var reMsAjax = /^\/Date\((d|-|.*)\)\/$/;

JSON.orgParse = JSON.parse;

JSON.parse = function(json, f)
{
    return JSON.orgParse(json,
                function(key, value) {
                    // if another function is passed, call it first.
                    if(f)
                    {
                        value = f(key, value);
                    }
                                            
                    if (typeof value === 'string') {
                        var a = reISO.exec(value);
                        if (a)
                            return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
                        a = reMsAjax.exec(value);
                        if (a) {
                            return new Date(parseInt(value.substr(6)));
                        }
                    }
                    return value;
                });
};

JSON.dateStringToDate = function(dtString) {
    var a = reISO.exec(dtString);
    if (a)
        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
    a = reMsAjax.exec(dtString);
    if (a) {
        var b = a[1].split(/[-,.]/);
        return new Date(+b[0]);
    }
    return null;
};

function getUTCDateISOString(d)
{
    function f(n)
    {
        // Format integers to have at least two digits.
        return n < 10 ? '0' + n : n;
    }

    return d.getUTCFullYear()   + '-' +
         f(d.getUTCMonth() + 1) + '-' +
         f(d.getUTCDate())      + 'T' +
         f(d.getUTCHours())     + ':' +
         f(d.getUTCMinutes())   + ':' +
         f(d.getUTCSeconds())   + 'Z';
}
